import { Chip, makeStyles } from '@material-ui/core';
import Datetime from 'react-datetime';
import styled from 'styled-components';


export const DatetimeWrapper = styled(Datetime)`
  & .rdtPicker {
    margin-top: 26px !important;
  }
`;

export const NoDataWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: inherit;
  padding-top: 24px;
  border-top: 1px solid #EEE;
  margin-top: 24px;
  color: #777;
  >h4 {
    font-weight: 400;
    margin: 5px 10px 0px 10px;
  }
  p {
    font-size: 0.9em;
  }
`;

export const ChipWrapper = styled.div`
  overflow: hidden;
`;

export const CompactChip = styled(Chip)`
  margin: 0px;
  height: 20px;
  margin-bottom: 2px;
  >span {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const useTableDateRangeStyles = makeStyles(theme => ({
  table: {
    maxHeight: '100%',

    '& div.rt-tbody': {
      paddingRight: '16px',
    },
  },
  dateInputContainer: {
    display       : 'flex',
    flexWrap      : 'wrap',
    justifyContent: 'center',
    gap           : theme.spacing(0),

    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      gap     : theme.spacing(4),
    },

    '& > div': {
      width: '100%',

      [theme.breakpoints.up('sm')]: {
        maxWidth: '370px',
      },
    },
  },
  tableWrapper: {
    overflow     : 'hidden',
    padding      : theme.spacing(1),
    '& div.rt-tr': {
      marginBottom: theme.spacing(0),
    },
    '& div.rt-th': {
      margin    : 0,
      padding   : '4px !important',
      display   : 'flex',
      alignItems: 'flex-end',
      width     : '100%',
    },
    '& div.rt-resizable-header-content': {
      overflow: 'inherit !important',
    },
    '& div.-pagination div.-center': {
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
      },
    },
    '& div.-pagination div.-center div.-pageJump': {
      [theme.breakpoints.down('sm')]: {
        width: '50px',
      },
    },

    '& div.-pagination button.-btn': {
      padding                     : theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
      },
    },
  },
  card: {
    [theme.breakpoints.down('sm')]: {
      marginTop   : theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
  },
}));


export const ContainerMultiSelect = styled.div`
  width: 100%;
  padding: 0 4px;
  
  & .MuiFormControl-root {
    padding: 0;
    margin: 0;
    padding-top: 24px;
  }
`;
